import { Fragment, useCallback, useEffect, useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeatures } from '../../store/featureSlice';

export default function FeatureTable() { 
  const { featurepageId } = useParams();
  const dispatch = useDispatch();
  const { features, error } = useSelector((state) => state.feature);

  // Function to handle displaying the check/cross based on value
  useEffect(() => {
    dispatch(fetchFeatures());
  }, [dispatch]);

  const renderIcon = useCallback((value) => {
    if (value === 'true') {
      return <img loading="lazy" src="/assets/home/table-check.png" alt="check" />;
    } else if (value === 'false') {
      return <img loading="lazy" src="/assets/home/table-cross.png" alt="cross" />;
    } else if (value && typeof value === 'string') {
      // Render the text content if it's not 'true' or 'false'
      return <>{value}</>;
    } else {
      return '';
    }
  }, []);

  const selectedFeature = useMemo(() => {
    return features?.find((feature) => feature.slug === featurepageId);
  }, [features, featurepageId]);

  const renderHTML = useCallback((htmlContent) => {
    return { __html: htmlContent };
  }, []);

  const headingLabels = useMemo(() => {
    return selectedFeature?.headings.map((_, index) => String.fromCharCode(65 + index));
  }, [selectedFeature]);

  const tableRows = useMemo(() => {
    return selectedFeature?.headings.map((heading, headingIndex) => (
      <Fragment key={headingIndex}>
        <tr className="table-HEAD">
          <td>{headingLabels[headingIndex]}.</td>
          <td>{heading.heading_name}</td>
          <td></td>
          <td></td>
        </tr>
        {heading.feature_points.map((point, pointIndex) => (
          <tr key={pointIndex}>
            <td>{pointIndex + 1}</td>
            <td dangerouslySetInnerHTML={renderHTML(point.point)} />
            <td>{renderIcon(point.basic)}</td>
            <td>{renderIcon(point.advanced)}</td>
          </tr>
        ))}
      </Fragment>
    ));
  }, [selectedFeature, renderHTML, renderIcon, headingLabels]);

  if (error) return <p>{error}</p>;
  if (!selectedFeature) return <p className='text-center'>No data found for this feature.</p>;
  return (
    <>
      <section className="featuretable-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="feature-table">
                <table className="table table-bordered">
                  <tr className='feat-heading'>
                    <td colSpan={2}>{selectedFeature.title}
                    </td>
                    <td>Basic</td>
                    <td>Advance</td>
                  </tr>

                  {tableRows}

                  <tr className='table-button'>
                    <td></td>
                    <td></td>
                    <td><Link to="/contact" className="default-btn animated-btn">BUY NOW</Link></td>
                    <td><Link to="/contact" className="default-btn animated-btn">BUY NOW</Link></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <img loading='lazy' src="/assets/home/featurtable-shape.webp" className='featurtable-vector' alt="shape" />
      </section>
    </>
  )
}
